// extracted by mini-css-extract-plugin
module.exports = {"toolbarButton":"Toolbox_toolbarButton__LN5xM","refreshBtn":"Toolbox_refreshBtn__3dxaf","clearIcon":"Toolbox_clearIcon__17XWM"};